module.exports = __webpack_public_path__ + "img/eu.ee7f471.svg";